import CoreCarousel from './CoreCarousel';

export { type CoreCarouselProps } from './CoreCarousel';
export default CoreCarousel;
